import { Controller } from "stimulus";
import Glide from "@glidejs/glide";
import { unveilImages, unveilImage } from "init/unveil";

const maxThumbs = 11;
const moveCount = 5;
const thumbWidth = 72;

export default class extends Controller {
  static targets = ["innerThumbnails"];

  connect() {
    this.sliders = this.element.querySelectorAll(".glide");
    this.count = this.element.querySelectorAll(".thumbnail").length;
    this.large_images = this.element.querySelectorAll(
      ".glide__slides [data-src]"
    );
    this.thumb_images = this.element.querySelectorAll(".thumbnails [data-src]");
    this.maxThumbs = maxThumbs;
    if (this.large_images.length) {
      window.addEventListener("load", this.mount.bind(this));
    }
  }

  openOverlay(e) {
    let index = Array.from(this.large_images).indexOf(e.target);
    let gallery_overlay = document.querySelector(".gallery-overlay");
    let slider = gallery_overlay.querySelector(".glide");
    gallery_overlay.classList.add("open");
    document.body.style.overflow = "hidden";
    let event = new CustomEvent("mount", { detail: index });
    slider.dispatchEvent(event);
  }

  unveilImages = unveilImages;
  unveilImage = unveilImage;

  mount() {
    let options = {
      type: "carousel"
    };
    this.sliders.forEach(slider => {
      if (!slider.hasAttribute("data-skip-mount")) {
        this.initSlider(new Glide(slider, options));
      } else {
        slider.addEventListener("mount", e => {
          let slider = e.srcElement;
          Object.assign(options, { startAt: e.detail });
          if (slider.dataset.glideInited === undefined) {
            slider.dataset.glideInited = true;
            this.overlay_slider = new Glide(slider, options);
            this.initSlider(this.overlay_slider);
          } else {
            this.overlay_slider.go(`=${e.detail}`);
          }
          this.setThumbnails(this.overlay_slider);
        });
      }
    });
  }

  initSlider(slider) {
    this.mainSlider = slider;
    let thumbs = this.element.querySelectorAll(".thumbnail");
    this.set(slider);
    Array.from(thumbs).forEach((thumb, index) => {
      thumb.addEventListener("click", () => slider.go(`=${index}`));
    });
    this.unveilImages(slider);
    // event called when slider moves
    slider.on("run", num => this.setThumbnails(slider));
    slider.on("resize", num => this.set(slider));
    slider.mount();
  }

  setThumbnails(slider) {
    // position thumbnail container
    let adjustedIndex = slider.index - moveCount;
    // first 6 set to beginning
    if (slider.index < moveCount) adjustedIndex = 0;
    // last 6 set to end
    if (slider.index >= this.count - moveCount)
      adjustedIndex = this.count - maxThumbs;
    let move = thumbWidth * adjustedIndex;
    this.innerThumbnailsTarget.style.transform = `translateX(-${move}px)`;
    this.set(slider);
    this.unveilImages(slider);
  }

  nextSlide() {
    this.mainSlider.go(">");
  }

  prevSlide() {
    this.mainSlider.go("<");
  }

  set(slider) {
    let index = slider.index;
    let slides = slider.selector.querySelectorAll(
      ".glide__slide:not(.glide__slide--clone)"
    );
    let currentSlide = slides[index];
    this.setActiveThumbnail(index);
    this.setIndex(index);
    this.setActiveSlideHeight(currentSlide);
  }

  setActiveSlideHeight(slide) {
    let img = slide.querySelector("img");
    let slides = document.querySelector(".pdp-hero .glide__slides");
    let naturalWidth = img.dataset.width || img.naturalWidth;
    let naturalHeight = img.dataset.height || img.naturalHeight;
    let maxHeight = getComputedStyle(slides).getPropertyValue("max-height");
    maxHeight = parseInt(maxHeight.replace("px", ""));

    let maxWidth = window.innerWidth < 1200 ? window.innerWidth : 1200;
    let scale = maxWidth / naturalWidth;
    let height = scale * naturalHeight;

    if (height > maxHeight) height = maxHeight;

    slides.style.height = `${height}px`;
  }

  setActiveThumbnail(index) {
    let thumbs = this.element.querySelectorAll(".thumbnail");
    let curThumb = thumbs[index];
    Array.from(thumbs).forEach(thumb => thumb.classList.remove("active"));
    if (curThumb) curThumb.classList.add("active");
  }

  setIndex(index) {
    this.element.querySelector("span.current").innerText = index + 1;
    this.element.querySelector("span.total").innerText = this.count;
  }
}
